import React from "react";

import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaMinus } from "react-icons/fa";
import Sidebar from "../../SideBar.js";

import axios from "axios";
import { useEffect, useState } from "react";

import Swal from "sweetalert2";
import HeaderName from "../../HeaderName";
import { set } from "../../../../assets/plugins/moment/src/lib/moment/get-set.js";
import { API_URL } from "../../../../api/index.js";

function LabServiceRegister() {
  const token = localStorage.getItem("token");
  const url = API_URL();
  const api = axios.create({
    baseURL: url,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  const [treatmentLists, setTreatmentLists] = useState([]);
  const [unitArr, setUnitArr] = useState([]);
  const [unitLists, setUnitLists] = useState([]);
  const [showUnitLists, setShowUnitLists] = useState([]);
  const [name, setName] = useState("");
  const [cost, setCost] = useState("");
  const [charges, setCharges] = useState("");
  const [status, setStatus] = useState("");
  const [packageLists, setPackageLists] = useState([]);
  const [description, setDescription] = useState("");
  const [tempPackage, setTempPackage] = useState("");
  const [showUnit, setShowUnit] = useState(false);
  const [treatmentUnit, setTreatmentUnit] = useState("");
  const [equalUnitID, setEqualUnitID] = useState([]);
  const [price, setPrice] = useState("");
  const [totalPrice, setTotalPrice] = useState("");
  const [pkgDiscountPercentage, setPkgDiscountPercentage] = useState("");
  const [pkgDiscountAmount, setPkgDiscountAmount] = useState("");
  const [sellingPrice, setSellingPrice] = useState(0);
  const [totalCost, setTotalCost] = useState("");
  const [eventUnified, setEventUnified] = useState("Yes");

  const [total, setTotal] = useState("");
  const [first, setFirst] = useState("");
  const [Id, setId] = useState("");
  const [showAdd, setShowAdd] = useState(false);
  var sumCost = 0;
  var sumPrice = 0;

  const handleAdd = (Id) => {
    setId(Id);
    setShowAdd(true);
  };

  const navigate = useNavigate();

  const [errors, setErrors] = useState({
    name: "",
    totalPrice: "",
    // totalCost: "",
    packageSellingPrice: "",
    relatedTreatments: "",
    status: "",
  });
  console.log(showUnitLists);

  const handleBox = (event) => {
    const selected = showUnitLists.find((el) => el._id == event);

    let UpdatedUnitArr;

    const existingIndex = unitArr.findIndex((item) => item.id == event);

    if (existingIndex !== -1) {
      UpdatedUnitArr = unitArr.map((item) =>
        item.id == event ? { ...item, qty: (item.qty || 1) + 1 } : item,
      );
    } else {
      const newPackage = {
        id: event,
        name: selected?.name || "",
        price: Number(selected?.estimateTotalPrice || 0),
        sellingPrice: Number(selected?.sellingPrice || 0),
        originalSellingPrice: Number(selected?.sellingPrice || 0),
        qty: 1,
        unitDiscountPercentage: 0,
      };
      UpdatedUnitArr = [...unitArr, newPackage];
    }

    let finalArr = [];

    if (eventUnified === "Yes") {
      const totalQty = UpdatedUnitArr.reduce(
        (acc, item) => acc + (item.qty || 1),
        0,
      );

      finalArr = UpdatedUnitArr.map((item) => ({
        ...item,
        unitDiscountPercentage: (((item.qty || 1) * 100) / totalQty).toFixed(2),
        sellingPrice: item.originalSellingPrice,
      }));
    } else {
      finalArr = UpdatedUnitArr;
    }

    const newTotalPrice = finalArr.reduce(
      (acc, item) => acc + item.originalSellingPrice * item.qty,
      0,
    );

    const newSellingPrice = finalArr.reduce(
      (acc, item) => acc + item.sellingPrice * item.qty,
      0,
    );

    const newTotalCost = finalArr.reduce(
      (acc, item) => acc + item.price * item.qty,
      0,
    );

    setUnitArr(finalArr);
    setTotalPrice(newTotalPrice);
    setSellingPrice(newSellingPrice);
    setTotalCost(newTotalCost);
  };

  const removeBox = (id) => {
    const newUnitArr = unitArr.filter((item) => item.id !== id);

    if (newUnitArr.length === 0) {
      setUnitArr([]);
      setTotalPrice(0);
      setSellingPrice(0);
      setTotalCost(0);
      return;
    }

    let finalArr = [];

    if (eventUnified === "Yes") {
      const totalQty = newUnitArr.reduce(
        (acc, item) => acc + (item.qty || 1),
        0,
      );

      finalArr = newUnitArr.map((item) => ({
        ...item,
        unitDiscountPercentage: (((item.qty || 1) * 100) / totalQty).toFixed(2),
        sellingPrice: item.originalSellingPrice,
      }));
    } else {
      finalArr = newUnitArr;
    }

    const newTotalPrice = finalArr.reduce(
      (acc, item) => acc + item.originalSellingPrice * item.qty,
      0,
    );

    const newSellingPrice = finalArr.reduce(
      (acc, item) => acc + item.sellingPrice * item.qty,
      0,
    );

    const newTotalCost = finalArr.reduce(
      (acc, item) => acc + item.price * item.qty,
      0,
    );

    setUnitArr(finalArr);
    setTotalPrice(newTotalPrice);
    setSellingPrice(newSellingPrice);
    setTotalCost(newTotalCost);
  };

  const TestPackageCreate = (event) => {
    event.preventDefault();
    let required = {};

    if (!name) required.name = "Package name is required";
    if (!totalPrice) required.totalPrice = "Total price is required";
    if (!sellingPrice)
      required.sellingPrice = "Package Selling Price is required";
    if (!status) required.status = "Status is required";

    if (Object.keys(required).length > 0) {
      setErrors(required);
      return;
    }

    setErrors({});

    const treatmentForPackage = unitArr.map((item) => ({
      treatment: item.id,
      qty: item.qty,
      sellingPrice: item.sellingPrice,
      discountPercent: Number(item.unitDiscountPercentage),
    }));

    const data = {
      name: name,
      description: description,
      treatmentForPackage: treatmentForPackage,
      totalPrice: totalPrice,
      totalCost: totalCost,
      sellingPrice: sellingPrice,
      status: status.toLowerCase(),
      isEvenUnified: eventUnified === "Yes",
    };

    const config = {
      headers: { "Content-Type": "application/json" },
    };

    api
      .post("package", data, config)
      .then((response) => {
        Swal.fire({
          title: "Success",
          text: "Package successfully created!",
          icon: "success",
          confirmButtonText: "OK",
        });
        navigate("/package");
      })
      .catch((err) => {
        Swal.fire({
          title: "Error",
          text: err.response?.data.message,
          icon: "error",
          confirmButtonText: "CANCEL",
        });
      });
  };

  const handleUnitDiscountChange = (id, value) => {
    const updated = unitArr.map((item) => {
      if (item.id === id) {
        const discountPercent = Number(value) || 0;

        return {
          ...item,
          unitDiscountPercentage: discountPercent,
        };
      }
      return item;
    });

    setUnitArr(updated);

    const newTotalPrice = updated.reduce(
      (acc, item) => acc + item.originalSellingPrice * item.qty,
      0,
    );

    const newSellingPrice = updated.reduce(
      (acc, item) => acc + item.sellingPrice * item.qty,
      0,
    );

    const newTotalCost = updated.reduce(
      (acc, item) => acc + item.price * item.qty,
      0,
    );

    setTotalPrice(newTotalPrice);
    setSellingPrice(newSellingPrice);
    setTotalCost(newTotalCost);
  };

  const handleUnit = (event) => {
    setShowUnitLists(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == event,
      ),
    );
    setShowUnit(true);
    setId("");

    console.log(
      unitLists.filter(
        (el) => (el.treatmentName ? el.treatmentName._id : "") == event,
      ),
    );
  };

  useEffect(() => {
    const getTreatment = async () => {
      try {
        const res = await api.get("treatment-lists");

        setTreatmentLists(res?.data.list);
        console.log(res?.data.list, "treat list");
      } catch (err) {}
    };

    const getUnitLists = async () => {
      try {
        const res = await api.get("treatments");

        setUnitLists(res?.data.list);
        // console.log(res.data.list, 'unit list')
        // setShowUnitLists(unitLists.filter(el => el._id == Id))
        // console.log(
        //   unitLists.filter(el => el._id == Id),
        //   'unit list'
        // )

        // console.log(res.data.data);
      } catch (err) {}
    };

    getUnitLists();
    getTreatment();
  }, []);

  useEffect(() => {
    if (eventUnified === "No") return;

    const price = Number(totalPrice) || 0;
    const percent = Number(pkgDiscountPercentage) || 0;

    const discount = (price * percent) / 100;
    const finalPrice = price - discount;

    setPkgDiscountAmount(discount);
    setSellingPrice(finalPrice);
  }, [totalPrice, pkgDiscountPercentage, eventUnified]);

  // useEffect(() => {
  //   const totalCost = unitArr.reduce((acc, item) => (acc += item.price), 0);

  //   setTotalCost(totalCost);
  //   const totalSellingPrice = unitArr.reduce(
  //     (acc, item) => (acc += item.sellingPrice),
  //     0,
  //   );
  //   setTotalPrice(totalSellingPrice);
  // }, [unitArr]);

  return (
    <div classNameName="App">
      <div className="wrapper">
        <div>
          {/* <!-- Content Header (Page header) --> */}
          <div className="content-header">
            <div className="container-fluid px-2">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/package">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active mt-1">
                      Package Register
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- Main content --> */}
          <section className="content" style={{ paddingBottom: "1.5rem" }}>
            <div className="container-fluid px-4">
              {/* <!-- Small boxes (Stat box) --> */}
              <div class="card">
                {/* <h3 className="text-center py-3">Test Package Register</h3> */}
                <div class="card-body p-b-0 py-5 px-5">
                  {/* @if($com == null) */}
                  <form onSubmit={TestPackageCreate}>
                    {/* @csrf */}
                    <div className="form-body">
                      <div className="form-group">
                        <label>Package Name</label>
                        <input
                          type="text"
                          id="name"
                          className="form-control"
                          onChange={(e) => setName(e.target.value)}
                        />
                        {errors?.name && (
                          <div className="text-danger">{errors?.name}</div>
                        )}
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <label className="control-label">
                            Add Treatments
                          </label>
                          <div className="row d-flex justify-content-between">
                            <div className="col-md-5">
                              <select
                                class="custom-select border-info"
                                name="account_type_id"
                                id="flag"
                                // placeHolder='Treatments'
                                onChange={(e) => {
                                  handleUnit(e.target.value);
                                }}
                              >
                                <option value="">Choose Treatments</option>
                                {treatmentLists.map((option) => (
                                  <option value={option._id}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>
                            </div>
                            {showUnit && (
                              <div className="col-md-5">
                                <select
                                  class="custom-select border-info"
                                  name="account_type_id"
                                  id="flag"
                                  value={Id}
                                  onChange={(e) => {
                                    handleAdd(e.target.value);
                                  }}
                                >
                                  <option value="">Choose Unit</option>
                                  {showUnitLists.map((option) => (
                                    <option value={option._id}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}

                            <div className="col-md-1">
                              <button
                                type="button"
                                disabled={!showAdd || !Id}
                                className="btn btn-primary"
                                onClick={() => handleBox(Id)}
                              >
                                <i class="fa fa-plus"></i>
                              </button>
                            </div>
                          </div>
                          {unitArr ? (
                            <div>
                              {unitArr.map((regArr, index) => (
                                <div className="row mt-3" key={regArr.id}>
                                  <div className="col-md-3">
                                    <label>Unit Name</label>
                                    <input
                                      type="text"
                                      value={regArr.name}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-1">
                                    <label>Qty</label>
                                    <input
                                      type="text"
                                      value={regArr.qty}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Purchase Price</label>
                                    <input
                                      type="text"
                                      value={regArr.price}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Selling Price</label>
                                    <input
                                      type="text"
                                      value={regArr.sellingPrice}
                                      className="form-control"
                                      readOnly
                                    />
                                  </div>
                                  <div className="col-md-2">
                                    <label>Discount (%)</label>
                                    <input
                                      type="number"
                                      value={regArr.unitDiscountPercentage}
                                      className="form-control"
                                      readOnly={eventUnified === "Yes"}
                                      onChange={(e) =>
                                        handleUnitDiscountChange(
                                          regArr.id,
                                          e.target.value,
                                        )
                                      }
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <button
                                      onClick={() => removeBox(regArr.id)}
                                      type="button"
                                      className="btn btn-sm btn-danger rounded-circle opacity-75"
                                      style={{ marginTop: "2.5em" }}
                                    >
                                      <FaMinus />
                                    </button>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                      <div className="form-group mt-2">
                        <label>Event unified</label>

                        <div>
                          <label style={{ marginLeft: "10px" }}>
                            <input
                              type="radio"
                              name="perUnit"
                              value="Yes"
                              checked={eventUnified === "Yes"}
                              onChange={(e) => setEventUnified(e.target.value)}
                            />
                            Yes
                          </label>
                          <label style={{ marginLeft: "10px" }}>
                            <input
                              type="radio"
                              name="perUnit"
                              value="No"
                              checked={eventUnified === "No"}
                              onChange={(e) => setEventUnified(e.target.value)}
                            />
                            No
                          </label>
                        </div>
                      </div>

                      <div className="form-group">
                        <label>Total Cost</label>
                        <input
                          type="number"
                          id="cost"
                          className="form-control"
                          value={totalCost}
                          onChange={(e) => setTotalCost(Number(e.target.value))}
                        />
                        {errors?.totalCost && (
                          <div className="text-danger">{errors?.totalCost}</div>
                        )}
                      </div>
                      <div className="form-group mt-3">
                        <label>Total Package Selling Price</label>
                        <input
                          type="number"
                          id="charge"
                          className="form-control"
                          value={totalPrice}
                          onChange={(e) =>
                            setTotalPrice(Number(e.target.value))
                          }
                        />
                        {errors?.totalPrice && (
                          <div className="text-danger">
                            {errors?.totalPrice}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label>Status</label>
                        <select
                          class="custom-select border-info"
                          name="account_type_id"
                          id="status"
                          onChange={(e) => setStatus(e.target.value)}
                        >
                          <option>Select Status</option>
                          <option value="Active">Active</option>
                          <option value="Pending">Pending</option>
                        </select>
                        {errors?.status && (
                          <div className="text-danger">{errors?.status}</div>
                        )}
                      </div>

                      <div className="col-md-12">
                        <label>Description</label>
                        <textarea
                          rows="8"
                          cols="40"
                          id="desc"
                          className="form-control"
                          onChange={(e) => setDescription(e.target.value)}
                        ></textarea>
                      </div>

                      <div className="form-actions mt-3">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="row">
                              <div className=" col-md-9">
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                >
                                  Create
                                </button>
                                &nbsp;
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  data-dismiss="modal"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  {/* <!-- /.row (main row) --> */}
                </div>
                {/*<!-- /.container-fluid --> */}
              </div>
            </div>
          </section>
          {/* <!-- /.content --> */}
        </div>

        {/* <!-- /.content-wrapper --> */}

        {/* <!-- Control Sidebar --> */}
        <aside className="control-sidebar control-sidebar-dark">
          {/* <!-- Control sidebar content goes here --> */}
        </aside>
        {/* <!-- /.control-sidebar --> */}
      </div>
      {/* <!-- ./wrapper --> */}
    </div>
  );
}
export default LabServiceRegister;
